/**
 * @class
 */
import Base from './assetConstituents_';
import Model from '../models/assetConstituent_layer';

export default class AssetConstituents_Layers extends Base {
	/** @type {string} */
	get type() {
		return 'layers';
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituents_Layers';
	}
}
